import React from 'react'
import { Spinner } from '../../common'
import { ChainId, Colors, PAIRS_BY_CHAIN } from '../../constants'
import { useEthers, useLiquidities } from '../../hooks'
import { useApiTokenRewards } from '../../providers'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { UnsupportedChainIdError } from '@web3-react/core'
import { LiquidityItem } from './LiquidityItem'

export function Liquidities() {
  const { chainId, account, error } = useEthers()

  const liquidities = useLiquidities()
  const apiTokenRewards = useApiTokenRewards()
  const currentPairs = PAIRS_BY_CHAIN[chainId ?? ChainId.Mainnet]
  const nonZeroPairs = currentPairs.filter((pair) => liquidities && liquidities[pair.address]?.gt(0))

  if (error instanceof UnsupportedChainIdError) {
    return (
      <Content>
        <StatusText>Unsupported network. Please connect with a supported network.</StatusText>
      </Content>
    )
  } else if (!account) {
    return (
      <Content>
        <StatusText>Connect your wallet to see your pool balances.</StatusText>
      </Content>
    )
  } else if (liquidities && Object.keys(liquidities).length === 0) {
    return (
      <Content>
        <StatusText>
          Loading your liquidity <Spinner />
        </StatusText>
      </Content>
    )
  } else if (nonZeroPairs.length > 0) {
    return (
      <Content>
        <List>
          {chainId &&
            nonZeroPairs.map((pair) => (
              <LiquidityItem
                key={pair.address}
                pair={pair}
                liquidityBalance={liquidities[pair.address]}
                lpRewards={apiTokenRewards && apiTokenRewards.lpRewards[pair.address.toLowerCase()]}
              />
            ))}
        </List>
      </Content>
    )
  } else {
    return (
      <Content>
        <StatusText>
          You haven't <Link to="/deposit">deposited</Link> into a pool, yet.
        </StatusText>
      </Content>
    )
  }
}

const Content = styled.div`
  min-height: 372px;
`

const List = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
`

const StatusText = styled.div`
  margin-bottom: 20px;
  padding: 20px;
  color: ${Colors.DarkerGray};
  font-size: 11px;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
`

const Link = styled(NavLink)`
  color: #557dcb;
`
